import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { HeroQuiet } from "@/components/landing/HeroQuiet";
import { FlowSection } from "@/components/landing/FlowSection";
import { NeverAgainList } from "@/components/landing/NeverAgainList";
import { TemplatesProof } from "@/components/landing/TemplatesProof";
import { PricingSingle } from "@/components/landing/PricingSingle";
import { FinalCTA } from "@/components/landing/FinalCTA";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroQuiet />
      <div id="flow">
        <FlowSection />
      </div>
      <NeverAgainList />
      <TemplatesProof />
      <div id="pricing">
        <PricingSingle />
      </div>
      <FinalCTA />
      <Footer />
    </div>
  );
};

export default Index;
